import { render, staticRenderFns } from "./SectionBePart.vue?vue&type=template&id=778f6de4&scoped=true"
import script from "./SectionBePart.vue?vue&type=script&lang=js"
export * from "./SectionBePart.vue?vue&type=script&lang=js"
import style0 from "./SectionBePart.vue?vue&type=style&index=0&id=778f6de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f6de4",
  null
  
)

export default component.exports